import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=c8b6ebfe&scoped=true&"
import script from "./Games.vue?vue&type=script&lang=js&"
export * from "./Games.vue?vue&type=script&lang=js&"
import style0 from "./Games.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Games.vue?vue&type=style&index=1&id=c8b6ebfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6ebfe",
  null
  
)

export default component.exports